'use strict'

import { flatClick } from '../../functions';
import { Buildings, projectMode, settingsData } from '../../settings';
import {openOptionsCard} from "./optionsCards";
import {changeLangToCurrent} from "../components/langSwitcher/langSwitcher";
import {ViewMode} from "../../common";
import {BaseElement} from "../interfaces/BaseElement";

export const createModal = (bmbyPropID) => {
    let apartmentData;
    let crmApartmentData;
    let currentBuilding;

    crmApartmentData = settingsData?.allCrmData.find(item => item.bmbyPropID === +bmbyPropID);

    if (crmApartmentData) {
        currentBuilding =  Buildings.getBuilding(crmApartmentData.buildingEngineId);
        apartmentData = currentBuilding.apartments.find(item => item.userData.crm_data.bmbyPropID === +bmbyPropID);
        if (currentBuilding)
            Buildings.activateBuilding(currentBuilding.name);
    }

    if (!apartmentData) {
        // return;
        for (let key in Buildings.buildings) {
            const customSelections = Buildings.buildings[key].customSelections
            customSelections.forEach((element) => {
                if (element.userData.name === bmbyPropID) {
                    apartmentData = element;
                    Buildings.activateBuilding(apartmentData.userData.crm_data.buildingEngineId);
                }
            })
        }

        return;
    }

    const aptExistText = 'propEnterPopup';
    // const aptErrorText = 'Property does not exist';
    const aptExistButton = 'No';
    // const aptErrorButton = 'Yes';

    const modal = new BaseElement()
      .addClass('modal__container', 'non-canvas')
      .appendTo(document.body)
      .DOMElement;
    new BaseElement()
      .addClass('modal__container-shade', 'non-canvas')
      .appendTo(document.body);
    const modalWrapper = new BaseElement()
      .addClass('modal__container-wrapper', 'non-canvas')
      .appendTo(modal)
      .DOMElement;
    new BaseElement()
      .addClass('modal__container-text', 'language-string')
      .addAttribute('data-dictionary', aptExistText)
      .innerHtml(changeLangToCurrent(aptExistText))
      .appendTo(modalWrapper);
    const buttonsBlock = new BaseElement()
      .addClass('modal__container-buttons-block')
      .appendTo(modalWrapper)
      .DOMElement;
    new BaseElement('button')
      .addClass('modal__container-close-btn', 'language-string', 'button')
      .addAttribute('data-dictionary', aptExistButton)
      .innerHtml(changeLangToCurrent(aptExistButton))
      .event('click', closeBtnClickHandler)
      .appendTo(buttonsBlock);

    if (apartmentData) {
        new BaseElement('button')
          .addClass('modal__container-btn', 'button', 'language-string')
          .addAttribute('data-dictionary', 'Enter')
          .addAttribute('data-menu-item', 'search')
          .innerHtml(changeLangToCurrent('Enter'))
          .event('click', (e) => buttonClickHandler(e, apartmentData))
          .appendTo(buttonsBlock);
    }
}

const buttonClickHandler = async (e, apartmentData) => {
    document.querySelector('.modal__container').remove();
    document.querySelector('.modal__container-shade').remove();

    settingsData.lastClickedFlat = apartmentData;

    const activeBuilding = Buildings.getActiveBuilding();
    await projectMode.Cylinder.enter(activeBuilding);
    await flatClick(apartmentData);
    openOptionsCard();
}

const closeBtnClickHandler = () => {
    projectMode.Pagination.paginate({source: 'urlModalCloseButton'});

    document.querySelector('.modal__container-close-btn').removeEventListener('click', closeBtnClickHandler);
    document.querySelector('.modal__container').remove();
    document.querySelector('.modal__container-shade').remove();

    const activeBuilding = Buildings.getActiveBuilding();
    if (activeBuilding) {
        if (settingsData.activeViewMode !== ViewMode.Cylinder)
            Buildings.deactivateBuilding();
    }

    // removePropParam();
}
